import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const CANONICAL_ORIGIN = "https://www.theappfam.com";
const DEFAULT_TITLE = "Aaron DPenha | The App Fam, Joshy, ScribeMind & Selah Daily";
const DEFAULT_DESCRIPTION =
  "Official website of Aaron DPenha, creator of Joshy, ScribeMind, and Selah Daily through The App Fam.";
const DEFAULT_KEYWORDS =
  "Aaron DPenha, Aaron Timothy DPenha, The App Fam, Joshy, Joshy AI, getjoshy, ScribeMind, Selah Daily";
const DEFAULT_IMAGE = `${CANONICAL_ORIGIN}/app-icons/hey-josh.png`;

const routeSeo = {
  "/": {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
    keywords: DEFAULT_KEYWORDS,
  },
  "/about": {
    title: "Aaron DPenha Official Bio | Creator of Joshy, ScribeMind & Selah Daily",
    description:
      "Learn about Aaron DPenha, creator of Joshy, ScribeMind, Selah Daily, and The App Fam.",
    keywords:
      "Aaron DPenha, Aaron Timothy DPenha, creator of Joshy, creator of ScribeMind, creator of Selah Daily, The App Fam",
  },
  "/apps": {
    title: "Joshy, ScribeMind & Selah Daily Apps by Aaron DPenha",
    description:
      "Explore The App Fam solutions by Aaron DPenha: Joshy for Vancouver reservations, ScribeMind for study notes, and Selah Daily for devotionals.",
    keywords:
      "Joshy, ScribeMind, Selah Daily, Aaron DPenha apps, The App Fam apps, AI apps by Aaron DPenha",
  },
  "/contact": {
    title: "Contact Aaron DPenha | The App Fam",
    description:
      "Contact Aaron DPenha at The App Fam about Joshy, ScribeMind, Selah Daily, support, or partnerships.",
    keywords:
      "contact Aaron DPenha, The App Fam contact, Joshy support, ScribeMind support, Selah Daily support",
  },
  "/joshy": {
    title: "Joshy by Aaron DPenha | AI Restaurant Reservations in Vancouver",
    description:
      "Joshy is an AI booking assistant by Aaron DPenha for Vancouver restaurant reservations, nearby parking, dining guidance, free events, services, and recreation.",
    keywords:
      "Joshy, Joshy AI, getjoshy, Aaron DPenha Joshy, Vancouver restaurant reservations, AI booking assistant, Vancouver parking, Vancouver events",
  },
  "/josh": {
    title: "Joshy by Aaron DPenha | AI Restaurant Reservations in Vancouver",
    description:
      "Joshy is an AI booking assistant by Aaron DPenha for Vancouver restaurant reservations, nearby parking, dining guidance, free events, services, and recreation.",
    keywords:
      "Joshy, Joshy AI, Aaron DPenha Joshy, getjoshy, Vancouver restaurant reservations",
    canonicalPath: "/joshy",
  },
  "/joshai": {
    title: "Joshy by Aaron DPenha | AI Restaurant Reservations in Vancouver",
    description:
      "Joshy is an AI booking assistant by Aaron DPenha for Vancouver restaurant reservations, nearby parking, dining guidance, free events, services, and recreation.",
    keywords:
      "Joshy AI, Joshy, Aaron DPenha Joshy, getjoshy, Vancouver AI booking assistant",
    canonicalPath: "/joshy",
  },
  "/scribemind": {
    title: "ScribeMind by Aaron DPenha | AI Study Notes & Lecture Exams",
    description:
      "ScribeMind by Aaron DPenha turns lectures and ideas into smart notes, summaries, and lecture-based exams so students can learn faster.",
    keywords:
      "ScribeMind, Aaron DPenha ScribeMind, AI study notes, lecture transcription app, AI lecture summaries, student study app",
    image:
      "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/4e/7e/70/4e7e701b-b155-7555-9ad5-272d142b325c/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/512x512bb.png",
  },
  "/scribe-mind": {
    title: "ScribeMind by Aaron DPenha | AI Study Notes & Lecture Exams",
    description:
      "ScribeMind by Aaron DPenha turns lectures and ideas into smart notes, summaries, and lecture-based exams so students can learn faster.",
    keywords:
      "ScribeMind, Aaron DPenha ScribeMind, AI study notes, lecture transcription app, AI lecture summaries",
    canonicalPath: "/scribemind",
  },
  "/selah-daily": {
    title: "Selah Daily by Aaron DPenha | Sermon Devotional App",
    description:
      "Selah Daily by Aaron DPenha records sermons, creates transcripts and summaries, and turns each message into a five-day devotional rhythm.",
    keywords:
      "Selah Daily, Aaron DPenha Selah Daily, sermon devotional app, AI sermon summaries, Christian devotional app, prayer wall",
    image:
      "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/47/0c/3c/470c3c27-5941-665f-1975-a68794e925e8/AppIcon-0-0-1x_U007emarketing-0-8-0-sRGB-85-220.png/512x512bb.png",
  },
  "/selahdaily": {
    title: "Selah Daily by Aaron DPenha | Sermon Devotional App",
    description:
      "Selah Daily by Aaron DPenha records sermons, creates transcripts and summaries, and turns each message into a five-day devotional rhythm.",
    keywords:
      "Selah Daily, Aaron DPenha Selah Daily, sermon devotional app, AI sermon summaries, Christian devotional app",
    canonicalPath: "/selah-daily",
  },
  "/privacy": {
    title: "Privacy Policy | The App Fam",
    description: "Read The App Fam's privacy policy and data handling practices.",
    keywords: "The App Fam privacy policy, Aaron DPenha privacy",
  },
  "/privacy/josh": {
    title: "Joshy Privacy Policy | The App Fam",
    description: "Privacy policy for Joshy by Aaron DPenha and The App Fam.",
    keywords: "Joshy privacy policy, Aaron DPenha Joshy privacy",
    canonicalPath: "/privacy/joshy",
  },
  "/privacy/joshy": {
    title: "Joshy Privacy Policy | The App Fam",
    description: "Privacy policy for Joshy by Aaron DPenha and The App Fam.",
    keywords: "Joshy privacy policy, Aaron DPenha Joshy privacy",
  },
  "/privacy/selah-daily": {
    title: "Selah Daily Privacy Policy | The App Fam",
    description: "Privacy policy for Selah Daily by Aaron DPenha and The App Fam.",
    keywords: "Selah Daily privacy policy, Aaron DPenha Selah Daily privacy",
  },
  "/privacy/scribemind": {
    title: "ScribeMind Privacy Policy | The App Fam",
    description: "Privacy policy for ScribeMind by Aaron DPenha and The App Fam.",
    keywords: "ScribeMind privacy policy, Aaron DPenha ScribeMind privacy",
  },
  "/terms": {
    title: "Terms of Service | The App Fam",
    description: "Terms of service for using The App Fam websites and applications.",
    keywords: "The App Fam terms, Aaron DPenha terms",
  },
  "/terms/josh": {
    title: "Joshy Terms & Conditions | The App Fam",
    description: "Terms and conditions for Joshy by Aaron DPenha and The App Fam.",
    keywords: "Joshy terms, Aaron DPenha Joshy terms",
    canonicalPath: "/terms/joshy",
  },
  "/terms/joshy": {
    title: "Joshy Terms & Conditions | The App Fam",
    description: "Terms and conditions for Joshy by Aaron DPenha and The App Fam.",
    keywords: "Joshy terms, Aaron DPenha Joshy terms",
  },
};

const setMetaContent = (name, content, isProperty = false) => {
  const selector = isProperty
    ? `meta[property="${name}"]`
    : `meta[name="${name}"]`;
  let el = document.head.querySelector(selector);

  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(isProperty ? "property" : "name", name);
    document.head.appendChild(el);
  }

  el.setAttribute("content", content);
};

const normalizePath = (pathname) => {
  if (!pathname || pathname === "/") return "/";
  return pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
};

const buildCanonicalUrl = (path) => {
  if (path === "/") return `${CANONICAL_ORIGIN}/`;
  return `${CANONICAL_ORIGIN}${path}`;
};

const SEOManager = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const normalizedPath = normalizePath(pathname);
    const page = routeSeo[normalizedPath] || routeSeo["/"];
    const canonicalPath = page.canonicalPath || normalizedPath;
    const canonicalUrl = buildCanonicalUrl(canonicalPath);
    const image = page.image || DEFAULT_IMAGE;

    document.title = page.title;
    setMetaContent("description", page.description);
    setMetaContent("keywords", page.keywords || DEFAULT_KEYWORDS);
    setMetaContent("og:title", page.title, true);
    setMetaContent("og:description", page.description, true);
    setMetaContent("og:url", canonicalUrl, true);
    setMetaContent("og:image", image, true);
    setMetaContent("twitter:title", page.title);
    setMetaContent("twitter:description", page.description);
    setMetaContent("twitter:image", image);

    const canonical = document.getElementById("canonical-link");
    if (canonical) {
      canonical.setAttribute("href", canonicalUrl);
    }
  }, [pathname]);

  return null;
};

export default SEOManager;
